import { useState } from "react";
import FadeIn from "../components/FadeIn";
import { ME } from "../constants/portfolioData";

/**
 * ExperienceSection
 * Tabbed layout — click a company name to reveal full details,
 * impact bullets, and tech stack for that role.
 */
const ExperienceSection = () => {
  const [activeExp, setActiveExp] = useState(0);
  const current = ME.experience[activeExp];

  return (
    <>
      <style>{`
        .exp-layout { display: grid; grid-template-columns: 200px 1fr; gap: 0; border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }
        .exp-tabs { border-right: 1px solid var(--border); background: var(--bg2); }
        .exp-tab { padding: 1.25rem 1.4rem; font-family: 'IBM Plex Mono', monospace; font-size: 0.8rem; font-weight: 500; color: var(--muted); cursor: pointer; transition: all 0.2s; border-left: 2px solid transparent; border-bottom: 1px solid var(--border); }
        .exp-tab:last-child { border-bottom: none; }
        .exp-tab:hover { color: var(--text); background: var(--bg3); }
        .exp-tab.act { color: var(--accent2); background: var(--bg3); border-left-color: var(--accent); }
        .exp-panel { padding: 2.5rem; background: #ffffff; }
        .exp-co { font-family: 'IBM Plex Sans', sans-serif; font-size: 1.5rem; font-weight: 700; color: var(--text); margin-bottom: 0.25rem; }
        .exp-role { font-family: 'IBM Plex Mono', monospace; font-size: 0.82rem; color: var(--accent2); margin-bottom: 0.2rem; }
        .exp-meta { font-family: 'IBM Plex Mono', monospace; font-size: 0.75rem; color: var(--muted); margin-bottom: 1.5rem; display: flex; gap: 1rem; flex-wrap: wrap; }
        .exp-desc { font-family: 'IBM Plex Sans', sans-serif; font-size: 0.95rem; line-height: 1.8; color: var(--muted2); margin-bottom: 1.5rem; }
        .impact-list { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 1.5rem; }
        .impact-item { display: flex; align-items: flex-start; gap: 0.6rem; font-family: 'IBM Plex Mono', monospace; font-size: 0.8rem; color: var(--text); }
        .impact-bullet { color: var(--accent); flex-shrink: 0; margin-top: 0.05rem; }
        .exp-stack { display: flex; flex-wrap: wrap; gap: 0.4rem; }
        .exp-tag { padding: 0.2rem 0.6rem; background: var(--accent-dim); border: 1px solid #3b82f630; border-radius: 4px; font-family: 'IBM Plex Mono', monospace; font-size: 0.72rem; color: var(--accent2); }
      `}</style>

      <section id="experience">
        <div className="wrap">
          <FadeIn><div className="sec-eyebrow">Work History</div></FadeIn>
          <FadeIn delay={0.05}>
            <h2 className="sec-title">Where I've <em>made an impact</em></h2>
          </FadeIn>
          <FadeIn delay={0.1}>
            <p className="sec-sub">
              {ME.byTheNumbers[0].n}+ years of measurable impact at companies from Series B to public stage.
              Real numbers, real systems.
            </p>
          </FadeIn>

          <FadeIn delay={0.15}>
            <div className="exp-layout">
              {/* Tab list */}
              <div className="exp-tabs">
                {ME.experience.map((e, i) => (
                  <div
                    key={e.company}
                    className={`exp-tab ${activeExp === i ? "act" : ""}`}
                    onClick={() => setActiveExp(i)}
                  >
                    {e.company}
                  </div>
                ))}
              </div>

              {/* Panel */}
              <div className="exp-panel">
                <div className="exp-co">{current.company}</div>
                <div className="exp-role">{current.role}</div>
                <div className="exp-meta">
                  <span>📅 {current.period}</span>
                  <span>💼 {current.type}</span>
                  <span>📍 {current.location}</span>
                </div>
                <div className="exp-desc">{current.desc}</div>
                <div className="impact-list">
                  {current.impact.map((imp) => (
                    <div key={imp} className="impact-item">
                      <span className="impact-bullet">▸</span>
                      <span>{imp}</span>
                    </div>
                  ))}
                </div>
                <div className="exp-stack">
                  {current.stack.map((t) => (
                    <span key={t} className="exp-tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </>
  );
};

export default ExperienceSection;